(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["inflatable-storefront"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',(event)=>{const button=event.target.closest('.if-filters button');if(!button)return;const section=button.closest('.if-shell');section.querySelectorAll('.if-filters button').forEach(el=>el.setAttribute('aria-pressed',String(el===button)));section.querySelectorAll('[data-holiday-group]').forEach(el=>{el.hidden=button.dataset.filter!=='all'&&el.dataset.holidayGroup!==button.dataset.filter;});});
window.addEventListener('hashchange',()=>{if(['#halloween','#thanksgiving','#christmas'].includes(window.location.hash)){document.querySelectorAll('[data-holiday-group]').forEach(el=>{el.hidden=false;});document.querySelectorAll('.if-filters button').forEach(el=>el.setAttribute('aria-pressed',String(el.dataset.filter==='all')));}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
